import ProfileArticleTags from './ProfileArticleTags'
import ProfileArticleFooter from './ProfileArticleFooter'

interface ProfileArticleContentProps {
  summary: string
  tags: string[]
  name: string
  type: string
  avatar: string
}

function ProfileArticleContent({
  summary,
  tags,
  name,
  avatar,
  type,
}: ProfileArticleContentProps) {
  const shortTitle = summary.slice(0, 30) + (summary.length > 30 ? '...' : '')
  const shortDesc = summary.slice(0, 85) + (summary.length > 85 ? '...' : '')

  return (
    <div className='flex h-[180px] py-[10px] flex-col items-end gap-[10px] flex-shrink-0 self-stretch'>
      <div className='flex flex-col items-start gap-3 self-stretch px-5 pt-3 pb-1'>
        <div>
          <p className='text-base font-medium leading-[24px] tracking-wide text-[#101828] h-[32px]'>
            {shortTitle}
          </p>
          <p className='text-xs font-normal leading-[16px] tracking-wide  text-[#6E7785] h-[32px]'>
            {shortDesc}
          </p>
        </div>
        <ProfileArticleTags tags={tags} />
      </div>
      <ProfileArticleFooter name={name} type={type} avatar={avatar} />
    </div>
  )
}

export default ProfileArticleContent
